import { onCreateMultisafe } from './onCreateMultisafe';
import { onLoadMultisafe } from './onLoadMultisafe';

export const thunks = {
    onCreateMultisafe,
    onLoadMultisafe,
};
